module.exports = {"id":"dp3_1l5q3","category":"3.1","text":"Develop Digital Content/Integrate & Modify Digital Content","instructions":"Screen capture software records your interactions with software.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp3_1l5q3-a1","text":"True","score":5.6},{"id":"dp3_1l5q3-a2","text":"Not sure","score":3.4},{"id":"dp3_1l5q3-a3","text":"False","score":3.4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l5q3.json
// module id = 1123
// module chunks = 41